import { SINGLE_NUMERIC, SINGLE_PATTERN } from './_argShapes';
import { STUB_NOT_IMPLEMENTED } from './_stubs';
import type { EffectEntry } from './types';

export const gain: EffectEntry = {
  kind: 'gain',
  category: 'effect',
  family: 'dynamics',
  doc: 'linear volume multiplier (0 silent, 0.7–1 typical, 1+ clips)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('gain', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('gain', 'fromAst'),
};

export const amp: EffectEntry = {
  kind: 'amp',
  category: 'effect',
  family: 'dynamics',
  doc: 'alias for gain at the sample-player stage',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('amp', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('amp', 'fromAst'),
};

export const velocity: EffectEntry = {
  kind: 'velocity',
  category: 'effect',
  family: 'dynamics',
  doc: 'MIDI-style per-note dynamics (0–1)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('velocity', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('velocity', 'fromAst'),
};

export const clip: EffectEntry = {
  kind: 'clip',
  category: 'effect',
  family: 'dynamics',
  doc: 'multiplies the note length (0.5 = staccato, 1 = legato, 2+ = overlap)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('clip', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('clip', 'fromAst'),
};

export const attack: EffectEntry = {
  kind: 'attack',
  category: 'effect',
  family: 'dynamics',
  doc: 'amp envelope attack in seconds (0.001 pluck, 0.5+ pad)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('attack', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('attack', 'fromAst'),
};

export const decay: EffectEntry = {
  kind: 'decay',
  category: 'effect',
  family: 'dynamics',
  doc: 'amp envelope decay in seconds',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('decay', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('decay', 'fromAst'),
};

export const sustain: EffectEntry = {
  kind: 'sustain',
  category: 'effect',
  family: 'dynamics',
  doc: 'sustain level (0–1) after decay',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('sustain', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('sustain', 'fromAst'),
};

export const release: EffectEntry = {
  kind: 'release',
  category: 'effect',
  family: 'dynamics',
  doc: 'amp envelope release in seconds',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('release', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('release', 'fromAst'),
};

export const adsr: EffectEntry = {
  kind: 'adsr',
  category: 'effect',
  family: 'dynamics',
  doc: 'four-arg envelope as a pattern string: "a d s r"',
  args: SINGLE_PATTERN,
  toCode: () => STUB_NOT_IMPLEMENTED('adsr', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('adsr', 'fromAst'),
};

export const ad: EffectEntry = {
  kind: 'ad',
  category: 'effect',
  family: 'dynamics',
  doc: 'two-arg attack+decay envelope as a pattern string: "a d"',
  args: SINGLE_PATTERN,
  toCode: () => STUB_NOT_IMPLEMENTED('ad', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('ad', 'fromAst'),
};

export const accelerate: EffectEntry = {
  kind: 'accelerate',
  category: 'effect',
  family: 'dynamics',
  doc: 'pitch slide during the note (negative = down, 1 = 1 octave/beat)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('accelerate', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('accelerate', 'fromAst'),
};

export const dough: EffectEntry = {
  kind: 'dough',
  category: 'effect',
  family: 'dynamics',
  doc: 'multi-voice chorus-y thickener (0–1)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('dough', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('dough', 'fromAst'),
};
